import { render, staticRenderFns } from "./ChatLightbox.vue?vue&type=template&id=ff8fe9be&"
import script from "./ChatLightbox.vue?vue&type=script&lang=js&"
export * from "./ChatLightbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports